import { StandardEvents } from '@shopify/events';

/**
 * THIRD Space: 商品ページの「カートに追加する」ボタンで追加に成功したら、
 * カートページ(/cart)へ自動的に遷移する。他の場所(クイック追加等)で
 * context: 'product'以外から発火したcartLinesUpdateは対象外。
 * エラー(在庫切れ等)の場合は画面に留まり、エラー表示をそのまま見せる
 * (遷移しない)。
 */
document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  if (event.action !== 'add' || event.context !== 'product') return;

  event.promise
    ?.then(({ cart, userErrors }) => {
      if (!cart || (userErrors && userErrors.length > 0)) return;
      window.location.href = Theme.routes.cart_url;
    })
    .catch((error) => {
      if (error?.name !== 'AbortError') console.warn('[cart-add-redirect] Cart update promise rejected:', error);
    });
});
